import React from 'react';
import { css } from 'linaria';
import { LinkWithGAClickButton } from '../../../link';
import { Typography } from '../../../typography';

const reviewsBenefitsLink = css`
  border-bottom: 2px solid var(--control-accent);
`;

export const MeasureBenefit: React.FC<{ elementBlock: string, href: string }> = ({ elementBlock, href }) => (
  <>
    <span>Сделаем</span>{'\n'}
    <LinkWithGAClickButton
      className={reviewsBenefitsLink}
      elementBlock={`${elementBlock} / Reviews`}
      elementName="Отзывы клиентов"
      elementText="Запишитесь"
      title="Запишитесь на проектирование"
      href={href}
      target="_blank">
      <Typography variant="m" size="body_long" color="text-invert">
        точный замер
      </Typography>
    </LinkWithGAClickButton>{' '}
  </>
);